import { errorToast } from '../utils/Toasts';

/* Обработка ответов != 200 */ 
export function ApiErrorHandler(error) {
	if (error.response) {
		// Сервер корректно ответил ошибкой. Наш NGINX так не умеет. Пока error.response всегда undefined 
		errorToast("Внимание! На сервере ведутся технические работы. В ближайшее время доступ к сервису восстановится. Приносим извинения за доставленные неудобства.");
		console.error(error.response);
	} else if (error.request) {
		// Запрос ушёл, но корректного ответа об ошибке нет
		errorToast('Ошибка связи с сервером! Проверьте своё интернет-соединение, выключите VPN, перезагрузите браузер, очистите кэш браузера, смените тип сети в вашем устройстве Wi-Fi/GSM. Попробуйте войти в кабинет через 30 минут.');
		console.error(error.message);
	} else {
		// Something happened in setting up the request that triggered an Error
		console.error('Error:', error.message);
	}
}